import { Link } from "react-router-dom";
import { t } from "ttag";

import { useModalsDisplayStore } from "@/app/stores";
import { TESTOSTERONE_STEP_ACTION_TYPES } from "@/shared/domains";
import type { TestosteroneStep } from "@/shared/domains";
import { useBoolean } from "@/shared/hooks";
import { Button, Dialog, VerifiedCheckIcon } from "@/shared/ui";

interface TestosteroneLabsNotificationModalProps {
  step: TestosteroneStep;
}

export const TestosteroneLabsNotificationModal = ({
  step,
}: TestosteroneLabsNotificationModalProps) => {
  const hasSeenModal = useModalsDisplayStore(
    (state) => state.hasSeenTestosteroneLabsNotification,
  );
  const markModalAsSeen = useModalsDisplayStore(
    (state) => state.markTestosteroneLabsNotificationAsSeen,
  );

  const { value: showModal, setFalse: closeModal } = useBoolean(
    Boolean(step) && !hasSeenModal,
  );

  const url = step.actions?.find(
    (action) =>
      action.type === TESTOSTERONE_STEP_ACTION_TYPES.SCHEDULE_CONSULTATION,
  )?.url;

  return (
    <Dialog.Root
      open={showModal}
      onOpenChange={() => {
        closeModal();
        markModalAsSeen(true);
      }}
    >
      <Dialog.Content>
        <Dialog.Header icon={VerifiedCheckIcon}>
          <Dialog.Title>{t`Labs are in!`}</Dialog.Title>

          <Dialog.Description>
            {t`Your results are ready. Meet with a provider to review your labs and take the next step in your treatment.`}
          </Dialog.Description>
        </Dialog.Header>

        {url && (
          <Dialog.Footer>
            <Button asChild size="lg" onClick={() => markModalAsSeen(true)}>
              <Link to={url}>{t`Schedule consultation`}</Link>
            </Button>
          </Dialog.Footer>
        )}
      </Dialog.Content>
    </Dialog.Root>
  );
};
